'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('..');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _DonateBanner = require('./DonateBanner.css');

var _DonateBanner2 = _interopRequireDefault(_DonateBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DonateBanner = (_dec = (0, _reactCssModules2.default)(_DonateBanner2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DonateBanner, _Component);

  function DonateBanner(props) {
    (0, _classCallCheck3.default)(this, DonateBanner);
    return (0, _possibleConstructorReturn3.default)(this, (DonateBanner.__proto__ || (0, _getPrototypeOf2.default)(DonateBanner)).call(this, props));
  }

  (0, _createClass3.default)(DonateBanner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-info' },
              _react2.default.createElement(
                'div',
                { styleName: 'banner-headline' },
                'Your support keeps this working'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-subtitle' },
                'Make a gift today to support As You Sow, a 501c3 non-profit'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-logo' },
                _react2.default.createElement(
                  _.Link,
                  { to: _config2.default.links.ays, title: 'As You Sow' },
                  _react2.default.createElement('div', { styleName: 'ays', title: 'As You Sow' }),
                  _react2.default.createElement(
                    _.SrOnly,
                    null,
                    'As You Sow'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'banner-button' },
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.links.donate,
                  donatebanner: true,
                  title: 'Donate'
                },
                'Donate',
                _react2.default.createElement(_.LinkIcon, { faclass: 'fa-heart' })
              )
            )
          )
        )
      );
    }
  }]);
  return DonateBanner;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = DonateBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DonateBanner/DonateBanner.js
// module id = 1273
// module chunks = 0